import { ViewPlugin } from '@codemirror/view';
import { setDiagnostics } from '@codemirror/lint';
import { isConnected } from "./connection-state.js";
import { addEvents } from "../../../helpers/add-events.js";
const timeout = 500;

const mapDiagnostic = ({
  span: {
    start,
    length
  },
  message,
  severity
}) => ({
  from: start,
  to: start + length,
  message,
  severity: severity
});

const createLinterPlugin = (view, connection, {
  slowUpdateResult
}) => {
  let suspended = !view.state.field(isConnected);
  let hadText = false;
  let timer = null;
  const removeConnectionEvents = addEvents(connection, {
    message(message) {
      if (message.type !== 'slowUpdate') return;
      const diagnostics = message.diagnostics.map(mapDiagnostic);
      diagnostics.sort((a, b) => {
        if (a.from > b.from) return 1;
        if (b.from > a.from) return -1;
        return 0;
      });
      view.dispatch(setDiagnostics(view.state, diagnostics));
      if (slowUpdateResult) slowUpdateResult(message);
    }

  });
  return {
    update({
      docChanged,
      state
    }) {
      const shouldSkipChange = timer || state.doc.length === 0 && !hadText;

      if (!state.field(isConnected)) {
        suspended = true;

        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

        return;
      } else if (suspended) {
        suspended = false; // if doc changed we will send an update below anyways

        if (!docChanged && !shouldSkipChange) {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          connection.sendSlowUpdate();
          return;
        }
      }

      if (!docChanged || shouldSkipChange) return;
      hadText = true;
      timer = setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        connection.sendSlowUpdate();
        timer = null;
      }, timeout);
    },

    destroy() {
      if (timer) clearTimeout(timer);
      removeConnectionEvents();
    }

  };
};

export const slowUpdateLinter = (connection, options) => [ViewPlugin.define(view => createLinterPlugin(view, connection, options))];